import { viewTechDocRouteRef } from '@agilelab/plugin-wb-builder-catalog';
import { BlueprintEntity } from '@agilelab/plugin-wb-builder-common';
import { WbDrawer } from '@agilelab/plugin-wb-platform';
import { DEFAULT_NAMESPACE } from '@backstage/catalog-model';
import { useApi, useRouteRef } from '@backstage/core-plugin-api';
import {
  ScmIntegrationIcon,
  scmIntegrationsApiRef,
} from '@backstage/integration-react';
import { Link } from '@backstage/core-components';
import { getEntitySourceLocation } from '@backstage/plugin-catalog-react';
import {
  TechDocsReaderPage,
  TechDocsReaderPageContent,
} from '@backstage/plugin-techdocs';
import { Box, IconButton, Tooltip, useTheme } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { FC, useState } from 'react';

interface Props {
  blueprint: BlueprintEntity;
}

export const BlueprintCardActions: FC<Props> = ({ blueprint }) => {
  const scmIntegrationsApi = useApi(scmIntegrationsApiRef);
  const sourceLocation = getEntitySourceLocation(blueprint, scmIntegrationsApi);
  const viewTechDoc = useRouteRef(viewTechDocRouteRef);
  const viewTechDocsAnnotation =
    blueprint.metadata.annotations?.['backstage.io/techdocs-ref'];
  const entityRef = {
    namespace: blueprint.metadata.namespace ?? DEFAULT_NAMESPACE,
    kind: blueprint.kind,
    name: blueprint.metadata.name,
  };
  const viewTechDocsLink =
    !!viewTechDocsAnnotation && !!viewTechDoc && viewTechDoc(entityRef);
  const [showDocs, setShowDocs] = useState<boolean>(false);
  const theme = useTheme();
  return (
    <Box style={{ display: 'flex', gap: '8px' }}>
      {sourceLocation && (
        <Tooltip title="Code">
          <IconButton
            component={Link}
            to={sourceLocation.locationTargetUrl ?? '#'}
            target="_blank"
            rel="noopener"
            color="secondary"
            size="small"
            aria-label="code"
            disabled={!sourceLocation.locationTargetUrl}
          >
            <ScmIntegrationIcon type={sourceLocation.integrationType} />
          </IconButton>
        </Tooltip>
      )}

      {viewTechDocsLink && (
        <Tooltip title="Documentation">
          <IconButton
            color="secondary"
            onClick={() => setShowDocs(true)}
            size="small"
            aria-label="documentation"
          >
            <InfoOutlinedIcon />
          </IconButton>
        </Tooltip>
      )}
      <WbDrawer
        open={showDocs}
        setOpen={setShowDocs}
        title={`${blueprint.metadata.name} Documentation`}
        contentContainerStyle={{
          overflow: 'hidden',
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <TechDocsReaderPage
          onClose={() => setShowDocs(false)}
          entityRef={entityRef}
        >
          <TechDocsReaderPageContent />
        </TechDocsReaderPage>
      </WbDrawer>
    </Box>
  );
};
